import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const ValueTypesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/ValueTypes",
    $_valueTypes: [],
    $_currentValueType: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allValueTypes: (state) => state.$_valueTypes,
    currentValueType: (state) => state.$_currentValueType,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initValueType({ commit }) {
      var valueType = {
        id: 0,
        key: "",
        name: "",
        description: "",
        isQuery: false,
        isArray: false,
        sqlQuery: "",
        parentId: null,
        valueTypeFields: []
      };

      commit("SET_VALUETYPE", valueType);
    },
    clearValueTypes({ commit }) {
      commit("SET_VALUETYPES", []);
    },
    setValueType({ commit }, valuetype) {
      commit("SET_VALUETYPE", valuetype);
    },
    async getValueTypes({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_VALUETYPES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getValueType({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_VALUETYPE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_VALUETYPES(state, value) {
      state.$_valueTypes = value;
    },
    SET_VALUETYPE(state, value) {
      state.$_currentValueType = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default ValueTypesVuexModule;
